// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ga-0";
export var fileCarousel = "_ga-2";
export var removeFileButton = "_ga-1";